// Champs d'une phase (objet de l'application) depuis le formulaire, selon sa méthode de
// facturation.
function amountsFromForm(form, fact) {
  const n = (v, d = 0) => parseFloat(v) || d;
  if (fact === 'forfait_global')
    return { joursTotal: n(form.joursTotal), montantGlobal: n(form.montantGlobal) };
  if (fact === 'forfait_brique') return { joursTotal: n(form.joursTotal) };
  if (fact === 'regie_temporelle' || fact === 'regie_horaire')
    return { nbDevs: n(form.nbDevs, 1), dureeMois: n(form.dureeMois, 1) };
  const maint = {
    correctifQte: n(form.correctifQte),
    correctifUnite: form.correctifUnite || 'heures_mois',
    montantGlobal: n(form.montantGlobal),
  };
  if (fact === 'maintenance_evolutive')
    return {
      ...maint,
      evolutifQte: n(form.evolutifQte),
      evolutifUnite: form.evolutifUnite || 'jours_an',
    };
  return fact === 'maintenance_corrective' ? maint : {};
}

/* Phase saisie au formulaire. Une phase issue d'une affaire convertie ne reprend que son nom, ses
   dates et sa clé Jira : ses montants se pilotent depuis l'affaire (CRM). */
export function phaseFromForm(form, fact, converted) {
  const base = {
    nom: form.nom,
    dateDebut: form.dateDebut || '',
    dateFin: form.dateFin || null,
    jira_project_key: form.jira_project_key || '',
  };
  if (converted) return base;
  return {
    ...base,
    facturation: fact,
    tjm: parseFloat(form.tjm) || 0,
    ...amountsFromForm(form, fact),
  };
}

/* Ligne de la table phases correspondant à une phase de l'application (champs présents seulement). */
export function phaseRow(ph) {
  const row = {
    nom: ph.nom,
    date_debut: ph.dateDebut,
    date_fin: ph.dateFin,
    jira_project_key: ph.jira_project_key,
  };
  if (!('facturation' in ph)) return row;
  return {
    ...row,
    facturation: ph.facturation,
    tjm: ph.tjm,
    jours_total: ph.joursTotal || 0,
    montant_global: ph.montantGlobal || 0,
    nb_devs: ph.nbDevs || 1,
    duree_mois: ph.dureeMois || 0,
    correctif_qte: ph.correctifQte || 0,
    correctif_unite: ph.correctifUnite || 'heures_mois',
    evolutif_qte: ph.evolutifQte || 0,
    evolutif_unite: ph.evolutifUnite || 'jours_an',
    date_fin_contrat: ph.dateFinContrat || '',
    echeance: ph.echeance || '',
  };
}
